export interface ResourceObject {
  id: string | number
  type: string
}

export interface ErrorObject {
  source?: { parameter: string }
  detail: string
  meta?: { associated_resources: any[]; resource: string }
  title: string
  status: string
}

export type ApiResource<Type = ResourceObject> = {
  data: Type
  links: Record<string, string>
  meta: Record<string, unknown>
}

export type ApiCollection<Type = ResourceObject> = {
  data: Type[]
  links: Record<string, string>
  meta: CollectionMeta
}

export interface FailedResponse extends Response {
  errors: ErrorObject[]
}

export interface NextPageCursor {
  offset?: string
  idLt?: string
  idLte?: string
  idGt?: string
  idGte?: string
}

export interface CollectionMeta {
  count: number
  totalCount: number
  next?: NextPageCursor
  prev?: NextPageCursor
  parent?: ResourceObject
  [attributeName: string]: unknown
}
